import { AppState } from '..';
import { Lounge } from './booking.types';

export const loungeSelector = (state: AppState): Lounge[] =>
  state.booking.lounge!;
